var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.528514 0.528514C0.788864 0.268165 1.21097 0.268165 1.47132 0.528514L4.99992 4.05711L8.52851 0.528514C8.78886 0.268165 9.21097 0.268165 9.47132 0.528514C9.73167 0.788864 9.73167 1.21097 9.47132 1.47132L5.47132 5.47132C5.21097 5.73167 4.78886 5.73167 4.52851 5.47132L0.528514 1.47132C0.268165 1.21097 0.268165 0.788864 0.528514 0.528514Z",
    fill: "#A9A9A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFooter);
export default __webpack_public_path__ + "static/media/arrow_footer.f5900c1f0edbf97d3bf791ec1252615c.svg";
export { ForwardRef as ReactComponent };